import React from "react";
import "./StoreIndicator.css";
import { useSelector } from "react-redux";

function StoreIndicator() {
  const currentSelectedStore = useSelector((state) => state.selectedStore);

  // Debug logging
  console.log("StoreIndicator - currentSelectedStore:", currentSelectedStore);

  // Don't show indicator if no store is selected
  if (!currentSelectedStore || !currentSelectedStore.storeName) {
    console.log("StoreIndicator - No store selected, not rendering");
    return null;
  }

  // Helper function to render store icon (emoji or sprite)
  const renderStoreIcon = () => {
    const { storeEmoji } = currentSelectedStore;
    if (storeEmoji && storeEmoji.startsWith('/')) {
      // Image sprite
      return (
        <img 
          src={storeEmoji} 
          alt={currentSelectedStore.storeName}
          className="store-indicator-sprite"
          style={{ 
            width: '16px', 
            height: '16px', 
            imageRendering: 'pixelated',
            imageRendering: '-moz-crisp-edges',
            imageRendering: 'crisp-edges'
          }}
        />
      );
    } else {
      // Regular emoji
      return <span className="store-indicator-emoji">{storeEmoji}</span>;
    }
  };

  return (
    <div className="store-indicator">
      {renderStoreIcon()}
      <span className="store-indicator-name">{currentSelectedStore.storeName}</span>
    </div>
  );
}

export default StoreIndicator;